import { Grid, Paper, TextField, Typography } from "@material-ui/core";

import { ServiceLaundryOptions } from "../../../graphql/models";
import { ListDatesPicker } from "../list_dates_picker";

export interface ServiceLaundryOptionsEditorProps {
  value: ServiceLaundryOptions | undefined;
  onChange: (serviceLaundryOpts: ServiceLaundryOptions) => void;
}

export function ServiceLaundryOptionsEditor(
  props: ServiceLaundryOptionsEditorProps
) {
  const { value, onChange } = props;

  const onFieldChange = (fieldName: string, fieldValue: any) => {
    onChange({
      ...(value ?? {}),
      [fieldName]: fieldValue,
    });
  };

  return (
    <Paper style={{ width: "100%", padding: "1rem" }}>
      <Grid container style={{ width: "100%" }} spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h5">
            Informazioni sull&apos;erogazione del servizio
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            style={{ width: "100%" }}
            label="Link al dettaglio su lavaggio e piegatura"
            placeholder="URL al link che spiega nel dettaglio il servizio di lavaggio e piegatura."
            variant="outlined"
            value={value?.washAndFoldDetailLink}
            onChange={(e) =>
              onFieldChange("washAndFoldDetailLink", e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">
            Date in cui il servizio non può essere erogato
          </Typography>
          <ListDatesPicker
            value={(value?.forbiddenDates ?? []).map((v) => new Date(v))}
            onChange={(e) =>
              onFieldChange(
                "forbiddenDates",
                e.map((v) => v.getTime())
              )
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
